<a
  class="login underline"
  [ngClass]="{ 'secondary-color-text': secondaryColor }"
  [href]="url"
>
  {{ text }}
</a>
